(function () {
	'use strict';
	angular.module('app.setup')
		.controller('flexFieldConfig', flexFieldConfig);

	flexFieldConfig.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', 'leanFilterService', 'leanTableService', 'tableRenderService', 'tableService', 'URLS', 'flexFieldConfigService', 'flexFieldConfigRendererService', '$experiments'];

	function flexFieldConfig($scope, $rootScope, $timeout, $uibModal, leanFilterService, leanTableService, tableRenderService, tableService, URLS, flexFieldConfigService, flexFieldConfigRendererService, $experiments) {
		var vm = this;

		vm.showActionButton = false;
		vm.reportName = 'Custom Supply Chain Fields';
		vm.showExcel = false;
		vm.initialLoad = true;
		vm.type = 'customer';
		vm.customerId = globalConfig.customer.id;

		vm.saveFlexField = saveFlexField;
		vm.deactivateFlexField = deactivateFlexField;
		vm.getMeta = getMeta;
		vm.getData = getData;

		var reportSettingsName = 'CustomSupplyChainFields';
		var fieldTypeMap = flexFieldConfigService.fieldTypeMap;
		var pinnedColumns = [];
		var rendererParams = {
			'controllerName': 'flexFieldConfigCtrl',
			'grayRow': true
		};
		var extraParams = [{}];
		var columns = [
			{
				'id': 'displayName',
				'display': 'Display Name',
				'width': 200,
				'renderer': flexFieldConfigRendererService.textEditRenderer,
				'enablePinning': false,
				'sort': false
			},{
				'id': 'filterTypeDisplay',
				'display': 'Filter Type',
				'width': 200,
				'renderer': flexFieldConfigRendererService.filterTypeRenderer,
				'enablePinning': false,
				'sort': false,
				'idField': 'id'
			},{
				'id': 'description',
				'display': 'Description',
				'width': 200,
				'renderer': flexFieldConfigRendererService.textEditRenderer,
				'enablePinning': false,
				'sort': false
			},{
				'id': 'sampleValue',
				'display': 'Sample Value',
				'width': 200,
				'enablePinning': false,
				'sort': false,
				'renderer': flexFieldConfigRendererService.textRenderer
			},{
				'id': 'parent',
				'display': 'Parent',
				'width': 200,
				'enablePinning': false,
				'sort': false,
				'renderer': flexFieldConfigRendererService.textRenderer
			},{
				'id': 'location',
				'display': 'Location',
				'width': 200,
				'enablePinning': false,
				'sort': false,
				'renderer': flexFieldConfigRendererService.textRenderer
			}
		];
		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: 'customSupplyChainFields',
			noPaging: true,
			noFactory: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'columnName',
			rendererParams: rendererParams,
			pageSize: 50,
			reportUrl: String.format(URLS.flexFields, globalConfig.customer.id) + '?withSamples=true',
			searchType: 'customSupplyChainField',
			hideSearch: true,
			extraParams: extraParams,
			setColumnDefaults: true,
			specialPlaceholderText: vm.searchPlaceholderText
		};


		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				var data = [];
				if (response && response[0].length) {
					angular.forEach(response[0], function (field) {
						if (!$rootScope.authz.isLeanDNACustomerAdmin() && (field.description == null || field.description == '')) {
							return;
						}
						data.push({
							'id': field.id,
							'columnName': field.fieldDefinition,
							'displayName': field.displayName ? field.displayName : '',
							'filterTypeDisplay': field.filterType ? field.filterType.filterTypeDisplay : '',
							'filterType': field.filterType ? field.filterType : '',
							'storageType': field.storageType ? field.storageType : '',
							'description': field.description ? field.description : '',
							'parent': field.sourceType,
							'location': fieldTypeMap[field.sourceType].location,
							'sampleValue': field.sampleValue,
							'customerId': field.customerId,
							'lastModified': field.lastModified,
							'isActive': field.displayName && field.displayName != '',
							'isConfigurable': (field.description && field.description != '') || vm.isLeanDNACustomerAdmin
						});
					});
					response[0] = data;
				}
				return response;
			});
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.loadFilters();
		}

		init();

		function saveFlexField(id, fieldDefinition, fieldName, value, lastModified) {
			var changes = {};
			if (fieldName === 'filterTypeDisplay') {
				changes['filterType'] = value['name'];
			} else {
				changes[fieldName] = value;
			}
			flexFieldConfigService.saveFlexField(id, fieldDefinition, changes, lastModified).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Configuration saved', 'success': true
					});
					$rootScope.$broadcast('reloadTable');
				} else if (response && response.status && response.status === 409) {
					$rootScope.$emit('toast', { 'message': response.data.error, 'success': false });
				} else if (response && response.status && response.status === 412) {
					$rootScope.$emit('toast', {
						'message': 'This field has been updated since you loaded the page, please refresh the page',
						'success': false
					});
				} else {
					$rootScope.$emit('toast', { 'message': 'Unexpected server error', 'success': false });
				}
			});
		}

		function deactivateFlexField(id, fieldDefinition, fieldName, lastModified) {
			if (fieldName === 'displayName') {
				saveDeactivateFlexField(id, fieldDefinition, { 'columnOrder': -1 }, lastModified);
				return;
			}

			var confirmScope = $scope.$new();
			confirmScope.fieldId = id;
			confirmScope.fieldDefinition = fieldDefinition;
			confirmScope.lastModified = lastModified;
			confirmScope.additionalText = 'deactivate this field for external users';
			confirmScope.buttonText = 'Remove description and deactivate';

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};
			
			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				var id = confirmScope.fieldId;
				var fieldDefinition = confirmScope.fieldDefinition;
				var lastModified = confirmScope.lastModified;
				instance.close();
				confirmScope.$destroy();
				saveDeactivateFlexField(id, fieldDefinition, {'displayName': '','description': '', 'columnOrder': -1}, lastModified);
			};
		}

		function saveDeactivateFlexField(id, fieldDefinition, changes, lastModified) {
			flexFieldConfigService.saveFlexField(id, fieldDefinition, changes, lastModified).then(function (response) {
				if (response && response.status && response.status == 200) {
					$rootScope.$emit('toast', {
						'message': 'Custom field configuration deactivated', 'success': true
					});
					$rootScope.$broadcast('reloadTable');
				} else {
					$rootScope.$emit('toast', { 'message': 'Unexpected server error', 'success': false });
				}
			});
		}
	}
})();
